import Hero from "../sections/hero";
import Homepage from "../sections/homepage";
import Footer from "../sections/footer";

function Home() {
  return (
    <div>
      <Hero heroImg={"homeHero"} title={"DESIGNED WITH PASSION, FOR LIFE"} />
      <Homepage />
      <Footer />
    </div>
  );
}

export default Home;
